(function(){
  function syncSelects(value){
    document.querySelectorAll('.mc-lip-variant-select').forEach(function(select){
      var option = Array.from(select.options).find(function(opt){return opt.value === value && !opt.disabled;});
      if(option){
        select.value = value;
        updatePrice(select);
      }
    });
  }
  function updatePrice(select){
    var option = select.options[select.selectedIndex];
    if(!option) return;
    var root = select.closest('.mc-lip-section') || document;
    var price = root.querySelector('[data-mc-lip-price]');
    var compare = root.querySelector('[data-mc-lip-compare]');
    if(price && option.dataset.price) price.textContent = option.dataset.price;
    if(compare && option.dataset.compare) compare.textContent = option.dataset.compare;
  }
  function chooseByText(text){
    if(!text) return;
    var select = document.querySelector('.mc-lip-variant-select');
    if(!select) return;
    var lower = text.toLowerCase();
    var option = Array.from(select.options).find(function(opt){
      return !opt.disabled && opt.textContent.toLowerCase().indexOf(lower) !== -1;
    });
    if(option){ syncSelects(option.value); }
  }
  function initVariants(root){
    (root || document).querySelectorAll('.mc-lip-variant-select').forEach(function(select){
      if(select.dataset.bound === 'true') return;
      select.dataset.bound = 'true';
      select.addEventListener('change', function(){
        updatePrice(select);
        syncSelects(select.value);
      });
    });
    (root || document).querySelectorAll('[data-mc-match]').forEach(function(btn){
      if(btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', function(){
        chooseByText(btn.getAttribute('data-mc-match'));
        (root || document).querySelectorAll('[data-mc-match]').forEach(function(x){x.classList.remove('is-active');});
        btn.classList.add('is-active');
      });
    });
  }
  function initReviewSliders(root){
    (root || document).querySelectorAll('.mc-lip-review-wrap').forEach(function(wrap){
      if(wrap.dataset.bound === 'true') return;
      wrap.dataset.bound = 'true';
      var track = wrap.querySelector('.mc-lip-review-track');
      var prev = wrap.querySelector('.mc-lip-review-prev');
      var next = wrap.querySelector('.mc-lip-review-next');
      if(!track) return;
      function cardWidth(){
        var card = track.querySelector('.mc-lip-review-card');
        if(!card) return 300;
        var gap = parseFloat(getComputedStyle(track).gap || 18);
        return card.getBoundingClientRect().width + gap;
      }
      if(prev) prev.addEventListener('click', function(){ track.scrollBy({left:-cardWidth(), behavior:'smooth'}); });
      if(next) next.addEventListener('click', function(){ track.scrollBy({left:cardWidth(), behavior:'smooth'}); });
    });
  }
  function init(root){ initVariants(root); initReviewSliders(root); }
  document.addEventListener('DOMContentLoaded', function(){ init(document); });
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
